export const ACTION_PREFIX = 'BUSINESS_DETAILS';

export const actionTypes = {
  UPDATE_BUSINESS_VALIDATION_RESULT: 'UPDATE_BUSINESS_VALIDATION_RESULT',
  RESET_BUSINESS_VALIDATION_RESULT: 'RESET_BUSINESS_VALIDATION_RESULT',
};
